import { Quantity, Unit } from '@elderbyte/ngx-starter'

export interface ShapeSizeConstraint {
  readonly maxWidth: Quantity
  readonly maxHeight: Quantity
  readonly maxLength: Quantity
  readonly maxVolume: Quantity
  readonly maxArea: Quantity
}

export const buildEmptyShapeSizeConstraint: () => ShapeSizeConstraint = () =>
  <ShapeSizeConstraint>{
    maxWidth: Quantity.zero(Unit.cm),
    maxHeight: Quantity.zero(Unit.cm),
    maxLength: Quantity.zero(Unit.cm),
    maxVolume: Quantity.zero(Unit.cm),
    maxArea: Quantity.zero(Unit.cm2),
  }
